import QualAPI from 'utils/QualAPI';
import useUpdateCodeField from './useUpdateCodeField';

/**
 * Hook for updating code synthesis with optimistic updates
 * @returns {Object} The mutation object with mutate function and state
 */
export function useUpdateCodeSynthesis() {
  return useUpdateCodeField(
    ({ codeId, synthesis }) => QualAPI.updateCodeSynthesis(codeId, synthesis).then(response => response.data),
    'Error updating code synthesis'
  );
}
